import styles from './BiometricClient.module.css'
import WebCamCaptureImage from "../../../FormTemplate/WebCamCaptureImage/WebCamCaptureImage";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import noImage from '../../../Img/Biometric/shot.svg'
import imgBuf from '../../../Img/Biometric/buff.png'
import ButtonContainer from "../../../FormTemplate/ButtonContainer/ButtonContainer";
import WaitLoader from "../../../WaitLoader/WaitLoader";
import TableItem, {TableItemCurrentStateInt, TableItemRef} from "../../../FormTemplate/TableItem/TableItem";
import DialogCamShot from "./DialogCamShot/DialogCamShot";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import DialogFullView from "./DialogFullView/DialogFullView";
import InputItemLight, {IRefInputItemLight} from "../../../FormTemplate/InputItemLight/InputItemLight";
import moment from "moment";
import {Link} from "react-router-dom";
import BioImageItem from "./BioImageItem/BioImageItem";
import NoteItem from "../../../FormTemplate/NoteItem/NoteItem";
import PhotoItem from "./PhotoItem/PhotoItem";
import useApiQueryBundle, {API_QUERY_ABORT, IApiQueryControl} from "../../../ApiQuery/UseApiQueryBundle";


interface iSimItem
{
    ctn:string
    icc:string
    activated:boolean
}
interface IDocUpdate
{
    clientId:number;
    family?: string;
    name?: string;
    middleName?: string;
    birthDate?: string;
    serial?: string;
    number?: string;
    issueDateFrom?: string;
    issuer?: string;
    gender?:"M"|"F"
    snils?:string;
    nation?:string;

}

interface INationItem {
    name:string
    code:string
}

interface IDocItem {
    family:string
    name:string
    middleName:string
    birthDate:string
    isoBirthDate:string|null

    docSerial:string
    docNumber:string
    docIssuer:string
    docDate:string
    isoDocDate:string|null
    gender:"M"|"F"

    shils:string
}

interface ITabItem
{
    id:number
    name:string
    logo?:string
}
interface IClientItem
{
    id:number
    esiaLogin:string
    number:string
    [key:string]:any
}
interface IEsiaItem
{
    clientId:number
    type:string
    esiaLogin: string
    date: Date
    val:string
}
interface ISimItem
{
    id:number
    ctn:string
    icc:string
    activated:boolean
    operId:string
    imei:string
    [key:string]:any
}

export default function BiometricClient()
{

    const [wFace, setWFace] = useState(false)
    const [wDoc, setWDoc] = useState(false)
    const [wCard, setWCard] = useState(false)

    const [nationList, setNationList]= useState<INationItem[]>([
        {name: "узб",code: "UZB"},
        {name: "тадж",code: "TJK"},
        {name: "каз",code: "KAZ"},
        {name: "инд",code: "IND"},
        {name: "кирг",code: "KGS"},
    ])
    const [nation,setNation]= useState("UZB")


    const crClientId = useRef(-1)


    const [needDocUpdateImg, setNeedDocUpdateImg] = useState(true)
    const [needCardOneUpdateImg, setNeedCardOneUpdateImg] = useState(true)
    const [needCardTwoUpdateImg, setNeedCardTwoUpdateImg] = useState(true)

    /*const [uploadLdrItem, setUploadLdrItem] = useState({
        ldrCardOne:false,
        ldrCardTwo:false
    })*/

    const [ldrCardOne, setLdrCardOne] = useState(false)
    const [ldrCardTwo, setLdrCardTwo] = useState(false)


    const refState = useRef<ErrorLineItemRef>(null)
    const refDocState = useRef<ErrorLineItemRef>(null)
    const refClientList = useRef<TableItemRef>(null)

    const refFamily = useRef<IRefInputItemLight>(null)
    const refName = useRef<IRefInputItemLight>(null)
    const refMiddleName = useRef<IRefInputItemLight>(null)
    const refBirthDate = useRef<IRefInputItemLight>(null)
    const refSerial = useRef<IRefInputItemLight>(null)
    const refNumber = useRef<IRefInputItemLight>(null)
    const refDocDate = useRef<IRefInputItemLight>(null)
    const refIssuer = useRef<IRefInputItemLight>(null)
    const refSnils = useRef<IRefInputItemLight>(null)

    const refSim = useRef<IRefInputItemLight>(null)
    const refImei = useRef<IRefInputItemLight>(null)

    const [pauseGmail, setPauseGmail] = useState(false)

    const [baseState, setBaseState] = useState<TableItemCurrentStateInt>()

    const dataClientUpdate = useRef<IDocUpdate>()
    const [ldrClientUpdate,rsClientUpdate,exClientUpdate] = useApiQuery("/biometric/client/update","post",dataClientUpdate);



    const dataEsiaNew = useRef<{
        clientId:number
    }>()
    const [ldrEsiaNew,rsEsiaNew,exEsiaNew] = useApiQuery("/biometric/client/esia/new","post",dataEsiaNew);


    const dataEsiaGmail = useRef<{
        clientId:number
    }>()
    const [ldrEsiaGmail,rsEsiaGmail,exEsiaGmail] = useApiQuery("/biometric/client/esia/gmail/read","post",dataEsiaGmail);


    const dataClientEsia = useRef<{
        clientId:number
    }>()
    const [ldrClientEsia,rsClientEsia,exClientEsia] = useApiQuery("/biometric/client/esia/list","post",dataClientEsia);
    const [esiaList, setEsiaList] = useState<IEsiaItem[]>([])


    const dataClientSimAdd = useRef<{
        clientId:number
        num:string
        imei:string
    }>()
    const [ldClientSimAdd,rsClientSimAdd,exClientSimAdd] = useApiQuery("/biometric/client/sim/add","post",dataClientSimAdd);


    const dataClientSimRemove = useRef<{
        id:number
    }>()
    const [ldClientSimRemove,rsClientSimRemove,exClientSimRemove] = useApiQuery("/biometric/client/sim/remove","post",dataClientSimRemove);


    const dataClientSimRefresh = useRef<{
        id:number
    }>()
    const [ldClientSimRefresh,rsClientSimRefresh,exClientSimRefresh] = useApiQuery("/biometric/client/sim/refresh","post",dataClientSimRefresh);

    const dataClientSimActivate = useRef<{
        id:number
    }>()
    const [ldClientSimActivate,rsClientSimActivate,exClientSimActivate] = useApiQuery("/biometric/client/sim/activate","post",dataClientSimActivate);

    const dataClientSim = useRef<{
        clientId:number
    }>()
    const [ldrClientSim,rsClientSim,exClientSim] = useApiQuery("/biometric/client/sim/list","post",dataClientSim);
    const [simList, setSimList] = useState<ISimItem[]>([])


    const [ldrNewClient,rsNewClient,exNewClient] = useApiQuery("/biometric/client/new","post",useRef(null));

    const [simData, setSimData] = useState<string>("")
    const [simImei, setSimImei] = useState<string>("000000000000000")


    const [docData, setDocData] = useState<IDocItem>({
        family:"", name:"",shils:"",birthDate:"",docDate:"",docIssuer:"MIA ",docNumber:"",docSerial:"",middleName:"",isoBirthDate:null,isoDocDate:null,gender:"M"
    })

    const dataLoadImage = useRef<{
        mode:number
        clientId:number
        //id:number
    }>()
//    const [ldrLoadImage,rsLoadImage,exLoadImage] = useApiQuery("/biometric/client/image","post",dataLoadImage);

    const imgMap = useRef(new Map<string, IApiQueryControl>())
    const [ldrLoadImage,exLoadImage] = useApiQueryBundle.useApiQueryPost("/biometric/client/image",dataLoadImage,{bundle: imgMap.current,single: true});



    const dataClientList = useRef()
    const [ldrClientList,rsClientList,exClientList] = useApiQuery("/biometric/client/list","post",dataClientList);
    const [clientList, setClientList] = useState<IClientItem[]>([])
    const [crClient, setCrClient] = useState<IClientItem>()







    const [imgFace, setImgFace] = useState(noImage)
    const [imgDoc, setImgDoc] = useState(noImage)
    const [imgCardOne, setImgCardOne] = useState(noImage)
    const [imgCardTwo, setImgCardTwo] = useState(noImage)

    const [tabList, setTabList] = useState<ITabItem[]>([
        {
            id:0,
            name:"Сэлфи"
        },
        {
            id:1,
            name:"Док"
        },
        {
            id:4,
            name:"Миг.карта"
        },
        {
            id:2,
            name:"Сим"
        },
        {
            id:3,
            name:"Госуслуги"
        },
    ])
    const [crTab,setCrTab] = useState(0)

    const data = useRef(new FormData())
    //const [ldrUploadItem,rsUploadItem,exUploadItem] = useApiQuery("/biometric/item/upload","file",data);
    const [ldrUploadItem,exUploadItem] = useApiQueryBundle.useApiQueryFile("/biometric/item/upload",data, true);


    const [camWith, setCamWith] = useState(window.innerWidth - 20)

    const [shot, setShot] = useState("")



    useEffect(()=>{
        switch (crTab) {
            case 0:
                loadImage(0)
                //loadFaceImage()
                break
            case 1:
                loadImage(1)
                //loadDocImage()
                //loadCardImage()
                parseClient()
                break
            case 2:
                loadSimList()
                break

            case 4:
                setNeedCardOneUpdateImg(true)
                setNeedCardTwoUpdateImg(true)
                //setUploadLdrItem({ldrCardOne: false,ldrCardTwo: false})
                setLdrCardTwo(false)
                //loadImage(2)
                //loadImage(3)
                break

            case 3:
                loadEsiaList()
                break
        }

    },[crTab])

    useEffect(()=>{
        if(! crClient) return
        crClientId.current = crClient?.id
        switch (crTab) {
            case 0:
                //setNeedImgUpdate(true)
                loadImage(0)
                //loadFaceImage()
                break
            case 2:
                loadSimList()
                break

            case 4:
                setNeedCardOneUpdateImg(true)
                setNeedCardTwoUpdateImg(true)
                break
            case 1:
                //loadDocImage()
               // loadCardImage()
                setNeedDocUpdateImg(true)
                parseClient()
                //loadImage(1)

                //setNeedCardUpdateImg(true)
                break
            case 3:
                loadEsiaList()
                break
        }


    },[crClient])


    useEffect(()=>{
        loadClientList()
    },[dataClientList])



    const loadEsiaList = ()=>{
        if(!crClient) return
        dataClientEsia.current = {clientId: crClient?.id}
        exClientEsia().then((e)=>{
            if(e?.success)
            {
                setEsiaList(e?.payload)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString: "Ошибка сервера",true,3000)
        })

    }


    const loadSimList = ()=>{
        if(!crClient) return
        dataClientSim.current={clientId: crClient?.id}
        exClientSim().then(e=>{
            if(e?.success)
            {
                setSimList(e?.payload)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)

        })
    }


    const loadImage = (mode:number)=>{
        if(!crClient) return
        //setImgDoc(noImage)
        switch (mode){
            case 2:
                //setUploadLdrItem({...uploadLdrItem,ldrCardOne: true})
                setLdrCardOne(true)
                break
            case 3:
                setLdrCardTwo(true)
                //setUploadLdrItem({...uploadLdrItem,ldrCardTwo: true})
                break
        }


        dataLoadImage.current = {mode: mode, clientId: crClient?.id}
        console.log("start ", crClient?.id)
        exLoadImage(mode?.toString()).then((e)=>{
            console.log("res",e, imgMap?.current)
            if(e?.success)
            {
                console.log("end ", crClientId?.current, mode)
                //if(crClientId?.current !== e?.payload?.clientId) return
                switch (mode)
                {
                    case 0:
                        setImgFace(`data:image/png;base64, ${e?.payload?.img}`)
                        break
                    case 1:
                        setImgDoc(`data:image/png;base64, ${e?.payload?.img}`)
                        setNeedDocUpdateImg(false)
                        break
                    case 2:
                        setImgCardOne(`data:image/png;base64, ${e?.payload?.img}`)
                        setNeedCardOneUpdateImg(false)
                        //setUploadLdrItem({...uploadLdrItem,ldrCardOne: false})
                        setLdrCardOne(false)

                        break
                    case 3:
                        setImgCardTwo(`data:image/png;base64, ${e?.payload?.img}`)
                        setNeedCardTwoUpdateImg(false)
                        setLdrCardTwo(false)
                        //setUploadLdrItem({...uploadLdrItem,ldrCardTwo: false})
                        break
                }

                return
            }
            switch (mode)
            {
                case 0:
                    setImgFace(noImage)
                    break
                case 1:
                    setImgDoc(noImage)
                    setNeedDocUpdateImg(false)
                    break
                case 2:
                    setImgCardOne(noImage)
                    setNeedCardOneUpdateImg(false)
                    //setUploadLdrItem({...uploadLdrItem,ldrCardOne: e?.code === API_QUERY_ABORT})
                    setLdrCardOne(e?.code === API_QUERY_ABORT)
                    break
                case 3:
                    setImgCardTwo(noImage)
                    setNeedCardTwoUpdateImg(false)
                    setLdrCardTwo(e?.code === API_QUERY_ABORT)
                    //setUploadLdrItem({...uploadLdrItem,ldrCardTwo: e?.code === API_QUERY_ABORT})
                    break
            }
        })

    }






    const loadClientList = ()=>{
        exClientList().then((e)=>{
            if(e?.success)
            {
                setClientList(e?.payload)
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)

        })

    }

    const parseClient = ()=>{
        if(! crClient) return
        setDocData({
            shils: crClient?.snils ? crClient?.snils : "",
            family: crClient?.family ? crClient?.family : "",
            name: crClient?.name ? crClient?.name : "",
            middleName: crClient?.middleName ? crClient?.middleName : "",

            birthDate: crClient?.birthDate ? moment(crClient?.birthDate).format("DD.MM.YYYY") : "",
            isoBirthDate:crClient?.birthDate ? moment(crClient?.birthDate).format("YYYY-MM-DD") : null,

            docSerial: crClient?.serial ? crClient?.serial : "",
            docNumber: crClient?.number ? crClient?.number : "",
            docIssuer: crClient?.issuer ? crClient?.issuer : "",
            gender: crClient?.gender && crClient?.gender?.match(/m/ui) ? "M" : "F",

            docDate: crClient?.issueDateFrom ? moment(crClient?.issueDateFrom).format("DD.MM.YYYY") : "",
            isoDocDate: crClient?.issueDateFrom ? moment(crClient?.issueDateFrom).format("YYYY-MM-DD") :null,





        })
        setNation(crClient?.nation ? crClient?.nation  : "UZB")

    }





    const buildTabList = ()=>{
        const x = tabList?.map((item,idx)=>{
            return (
                <div className={[styles.tabItem, item?.id===crTab ? styles.actTabItem : ""].join(' ')} key={idx}
                    onClick={()=>setCrTab(item?.id)}
                >
                    {item?.name}
                </div>
            )
        })
        return(
            <div className={styles.tabRowCont}>
                {x}
            </div>
        )

    }




    const uploadImage = (e: string, mode:number) =>{
        switch (mode) {
            case 0:
                setImgFace(e)
                break
            case 1:
                setImgDoc(e)
                break
            case 2:
                setImgCardOne(e)
                break
            case 3:
                setImgCardTwo(e)
                break
        }


        if(!crClient) return
        data.current.delete('file')
        data.current.delete('data')
        data.current.append('data', JSON.stringify({mode:mode, clientId:crClient?.id}))
        const blob = new Blob([e], {type : 'text/plain'})
        data.current.append('file', blob ,"base64.png");


        exUploadItem().then((e)=>{
            if(e?.success)
            {
                if(refState.current)refState.current.show("Фото загружено", false, 2000)
                switch (mode)
                {
                    case 0:
                        break
                    case 1:
                        setNeedDocUpdateImg(false)
                        break
                    case 2:
                        setNeedCardOneUpdateImg(false)
                        break
                    case 3:
                        setNeedCardTwoUpdateImg(false)
                        break
                }

                return
            }
            //            setDgFaceShot(false)
  //          loadFaceImage()
        })
    }




    const buildFaceCont = ()=>{
        return(
            <div className={styles.fcCont}>

                <div className={styles.fcImgFrame}>
                    <PhotoItem
                        onPhoto={(e)=>{uploadImage(e,0)}}
                        img={imgFace}
                        canPhoto={!!crClient}
                        load={ldrUploadItem || ldrLoadImage }
                        frameType={0}
                        imgHeight={350}
                        title={"Сэлфи"}
                        needUpdate={false}
                    />
                </div>
            </div>
        )
    }


    const buildGender = ()=>{
        const m = docData?.gender === "M"
        return (
            <div className={styles.gCont}>
                <div className={styles.gTitle}>Пол</div>
                <div className={styles.gLine}>
                    <div className={[styles.gItem, m ? styles.gItemActive : ""].join(' ')}
                        onClick={()=>{
                            setDocData({...docData, gender: "M"})
                        }}
                    >М</div>
                    <div className={[styles.gItem, !m ? styles.gItemActive : ""].join(' ')}
                         onClick={()=>{
                             setDocData({...docData, gender: "F"})
                         }}
                    >Ж</div>
                </div>
            </div>
        )


    }

    const buildNationList=()=>{
        const x = nationList?.map((item,idx)=>{
            const active = item?.code === nation
            return(
                <div key={idx} className={[styles.nlItem, active ? styles.nlContActive : ""].join(' ')}
                    onClick={()=>setNation(item?.code)}
                >{item?.name}</div>
            )
        })
        return(
            <div className={styles.nlCont}>{x}</div>
        )
    }


    const buildCardCont = ()=>{
        return(
            <div className={styles.fcCont}>
                <div className={styles.docCont}>
                    <div className={styles.docImgCont}>
                        <div className={styles.fcImgFrame}>
                            <PhotoItem
                                onPhoto={(e)=>{uploadImage(e,2)}}
                                img={imgCardOne}
                                canPhoto={!!crClient}
                                load={ldrCardOne}
                                frameType={1}
                                imgHeight={350}
                                title={"мигр. карта 1-ая сторона"}
                                needUpdate={needCardOneUpdateImg}
                                onUpdate={()=>loadImage(2)}
                            />
                        </div>
                        <div className={styles.fcImgFrame}>
                            <PhotoItem
                                onPhoto={(e)=>{uploadImage(e,3)}}
                                img={imgCardTwo}
                                canPhoto={!!crClient}
                                load={ldrCardTwo}
                                frameType={1}
                                imgHeight={350}
                                title={"мигр. карта 2-я сторона"}
                                needUpdate={needCardTwoUpdateImg}
                                onUpdate={()=>loadImage(3)}
                            />
                        </div>

                    </div>


                </div>


            </div>
        )

    }


    const buildDocCont = ()=>{
        return(
            <div className={styles.fcCont}>
                <div className={styles.docCont}>
                    <div className={styles.docImgCont}>
                        <div className={styles.fcImgFrame}>
                            <PhotoItem
                                onPhoto={(e)=>{uploadImage(e,1)}}
                                img={imgDoc}
                                canPhoto={!!crClient}
                                load={ldrUploadItem || ldrLoadImage}
                                frameType={1}
                                imgHeight={350}
                                title={"Документ"}
                                needUpdate={needDocUpdateImg}
                                onUpdate={()=>loadImage(1)}
                            />
                        </div>

                    </div>
                    <hr style={{width:"100%"}}></hr>
                    <div className={[styles.docTextCont, crClient ? "" : "d-none"].join(' ')}>
                        <form >
                            <div className="row g-1 mb-1">
                                <div className="col-md-4">
                                    <InputItemLight
                                        ref={refFamily}
                                        mode={"e"}
                                        placeHolder={"Фамилия"}
                                        canEmpty={false}
                                        regExp={/^[a-zа-я-\s]{2,30}$/ui}
                                        val={docData?.family}
                                        onChange={(e)=> {
                                            setDocData({... docData, family: normName(e)})
                                        }}
                                        onlySpace={false}

                                        titleColNumber={4}
                                        title={"Фамилия"}
                                        classInput={styles.docInp}
                                        classTitle={styles.docInp}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <InputItemLight
                                        ref={refName}
                                        mode={"e"}
                                        title={"Имя"}
                                        titleColNumber={4}
                                        classInput={styles.docInp}
                                        classTitle={styles.docInp}
                                        regExp={/^[a-zа-я-\s]{2,30}$/ui}

                                        placeHolder={"Имя"}
                                        canEmpty={false}
                                        val={docData?.name}
                                        onChange={(e)=> {
                                            setDocData({... docData, name: normName(e)})
                                        }}


                                    />
                                </div>
                                <div className="col-md-4">
                                    <InputItemLight
                                        ref={refMiddleName}
                                        mode={"e"}
                                        title={"Отчество"}
                                        titleColNumber={4}
                                        classInput={styles.docInp}
                                        classTitle={styles.docInp}
                                        regExp={/(^[a-zа-я-\s]{2,30}$)|(^$)/ui}

                                        placeHolder={"Отчество"}
                                        canEmpty={true}
                                        val={docData?.middleName}
                                        onChange={(e)=> {
                                            setDocData({... docData, middleName: normName(e)})
                                        }}

                                    />
                                </div>
                            </div>
                            <div className="row g-1 mb-1">
                                <div className="col-md-4">
                                    <InputItemLight
                                        ref={refBirthDate}
                                        mode={"e"}
                                        title={"Дата рожд."}
                                        classInput={styles.docInp}
                                        classTitle={styles.docInp}
                                        regExp={/^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/ui}
                                        inputType={"numeric"}
                                        placeHolder={"XX.XX.XXXX"}
                                        canEmpty={false}
                                        val={docData?.birthDate}
                                        onChange={(e)=> {
                                            const x = normDate(e)
                                            setDocData({... docData, birthDate: x.text, isoBirthDate: x.iso})
                                        }}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <InputItemLight
                                        ref={refSerial}
                                        mode={"e"}
                                        title={"Серия"}
                                        maxLen={4}

                                        classInput={styles.docInp}
                                        classTitle={styles.docInp}
                                        regExp={/^([\w]+)|(^$)$/ui}
                                        placeHolder={"Серия"}
                                        canEmpty={true}
                                        val={docData?.docSerial}
                                        onChange={(e)=> {
                                            setDocData({... docData, docSerial: (e.trim().toUpperCase())})
                                        }}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <InputItemLight
                                        ref={refNumber}
                                        mode={"e"}
                                        title={"Номер"}
                                        classInput={styles.docInp}
                                        classTitle={styles.docInp}
                                        regExp={/^[\w0-9]{3,}$/ui}
                                        placeHolder={"Номер"}
                                        canEmpty={false}
                                        maxLen={6}
                                        val={docData?.docNumber}
                                        onChange={(e)=> {
                                            setDocData({... docData, docNumber: (e.trim().toUpperCase())})
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row g-1 mb-1">
                                <div className="col-md-4">
                                    <InputItemLight
                                        ref={refDocDate}
                                        mode={"e"}
                                        title={"Дата выдачи"}
                                        classInput={styles.docInp}
                                        classTitle={styles.docInp}

                                        regExp={/^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/ui}
                                        inputType={"numeric"}
                                        placeHolder={"XX.XX.XXXX"}
                                        canEmpty={false}
                                        val={docData?.docDate}
                                        onChange={(e)=> {
                                            const x = normDate(e)
                                            setDocData({... docData, docDate: x.text, isoDocDate: x.iso})
                                        }}

                                    />
                                </div>
                                <div className="col-md-4">
                                    <InputItemLight
                                        ref={refSnils}
                                        mode={"e"}
                                        title={"СНИЛС"}
                                        classInput={styles.docInp}
                                        titleColNumber={4}
                                        classTitle={styles.docInp}
                                        maxLen={11}

                                        regExp={/(^[0-9]{11}$)|(^$)/ui}
                                        inputType={"numeric"}
                                        placeHolder={"XXXXXXXXXXX"}
                                        canEmpty={true}
                                        val={docData?.shils}
                                        onChange={(e)=> {
                                            setDocData({... docData, shils: (e.trim())})
                                        }}

                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputItemLight
                                        ref={refIssuer}
                                        mode={"e"}
                                        title={"Кем выдан"}
                                        classInput={styles.docInp}
                                        classTitle={styles.docInp}
                                        titleColNumber={5}
                                        maxLen={40}

                                        placeHolder={"Кем выдан"}
                                        canEmpty={true}
                                        val={docData?.docIssuer}
                                        onChange={(e)=> {
                                            setDocData({... docData, docIssuer: (e.trim())})
                                        }}

                                    />
                                </div>
                                <div className="col-md-1">
                                    {buildGender()}
                                </div>
                            </div>
                            <div className="row g-1 mb-1">
                                <div className="col-md-4">
                                    {buildNationList()}
                                </div>
                            </div>

                        </form>
                        <ButtonContainer resize={true} my={10}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={handleDocUpdate}
                                    disabled={!crClient}
                            >Сохранить</button>
                            <div className={styles.docStateCont}>
                                <ErrorLineItem ref={refDocState}></ErrorLineItem>

                            </div>

                        </ButtonContainer>

                    </div>


                </div>


            </div>
        )
    }


    const handleSimRemove = (sim:ISimItem)=>{
        if(! crClient || !refState.current) return
        if(sim.activated){
            refState.current.show("Нельзя удалить уже зарегестрированную карту", true, 5000)
            return
        }
        const quest = window.confirm("Вы уверены что хотите удалить sim карту?")
        if(! quest) return
        dataClientSimRemove.current = {id: sim?.id}
        exClientSimRemove().then((e)=>{
            if(e?.success)
            {
                loadSimList()
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)
        })
    }
    const handleSimRefresh = (sim:ISimItem)=>{
        if(! crClient || !refState.current) return
        if(sim.activated){
            refState.current.show("Нельзя обновить уже зарегестрированную карту", true, 5000)
            return
        }
        dataClientSimRefresh.current = {id: sim?.id}
        exClientSimRefresh().then((e)=>{
            if(e?.success)
            {
                if(refState.current)refState.current.show( "Данные обновлены",false,2000)
                loadSimList()
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)
        })
    }
    const handleSimActivate = (sim:ISimItem)=>{
        if(! crClient || !refState.current) return
        if(sim.activated){
            refState.current.show("Нельзя активировать уже зарегестрированную карту", true, 5000)
            return
        }
        const quest = window.confirm("Вы уверены что хотите активировать sim карту?")
        if(! quest) return
        dataClientSimActivate.current = {id: sim?.id}
        exClientSimActivate().then((e)=>{
            if(e?.success)
            {
                if(refState.current)refState.current.show( "Процесс активации запущен",false,2000)
                loadSimList()
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)
        })
    }

    const buildSimList = ()=>{
        const x = simList?.map((item,idx)=>{
            return(
                <div key={idx} className={styles.simContX}>
                    <div className={styles.simBlock}>
                        <div className={[styles.smCtn].join(' ')}>{item?.ctn ? item?.ctn : "-"}
                            <div className={[styles.smAct,item?.activated ? styles.smIsActive : ""].join(' ')}></div>
                        </div>
                        <div className={styles.smIcc}>
                            {item?.icc ? item?.icc : "-"}
                        </div>
                        <div className={styles.smImei}>
                            i:{item?.imei ? item?.imei : "-"}
                        </div>

                    </div>
                    {item?.info && <div className={styles.smInfo}>{item?.info}</div>}

                    <div className={styles.simOpCont}>
                        {item?.operId && <div className={styles.smOperName}>{item?.operId}</div>}
                        <button type="button" className={["btn btn-face", styles.smActBut].join(' ')}
                            disabled={item?.activated}
                                onClick={()=>handleSimActivate(item)}
                        >акт</button>
                        <div className={styles.smBIconCont}>
                            <i className='bx bx-refresh'
                                onClick={()=>handleSimRefresh(item)}
                            ></i>
                            <i className='bx bx-message-alt-x'
                               onClick={()=>handleSimRemove(item)}
                            ></i>

                        </div>
                    </div>

                </div>
            )
        })
        return(
            <div className={styles.smBlockCont}>
                    {x}

            </div>
        )
    }

    const buildSimCont = ()=>{
        return(
            <div className={styles.simCont}>

                <div className={"row w-100"}>
                    <div className={"d-flex col-md-12 justify-content-center my-2"}>
                        {buildSimList()}
                    </div>

                </div>

                <div className={"row w-100 my-1"}>
                    <div className={"d-flex col-md-6 justify-content-center"}>
                        <InputItemLight
                            mode={"e"}
                            title={"СИМ Карта"}
                            placeHolder={"XXXXXXXXXXXXXXXXXXXXXXXX"}
                            val={simData}
                            regExp={/^[0-9]{10,24}$/ui}
                            inputType={"numeric"}
                            onChange={(e)=>{
                                setSimData(e)
                            }}
                            minWidth={"100%"}
                            //onlySpace={false}
                            titleColNumber={4}
                            maxLen={23}
                            trim={true}
                            canEmpty={false}
                            ref={refSim}
                            info={"Номер или icc сим карты"}
                        />
                    </div>
                    <div className={"d-flex col-md-6 justify-content-center"}>
                        <InputItemLight
                            mode={"e"}
                            title={"IMEI"}
                            minWidth={"100%"}
                            placeHolder={"XXXXXXXXXXXXXXXXXXXXXXXX"}
                            val={simImei}
                            regExp={/^[0-9]{14,16}$/ui}
                            inputType={"numeric"}
                            onChange={(e)=>{
                                setSimImei(e)
                            }}
                            //onlySpace={false}
                            titleColNumber={4}
                            maxLen={16}
                            trim={true}
                            canEmpty={false}
                            ref={refImei}
                            info={"imei телефона"}
                        />
                    </div>
                </div>
                <ButtonContainer my={10} resize={true}>
                    <button type="button" className="btn btn-face "
                        onClick={handleAddSim}
                            disabled={!crClient}
                    >Добавить</button>

                </ButtonContainer>
            </div>
        )
    }


    const handleAddSim = ()=>{
        if(! refSim.current || !refState.current || !crClient || !refImei.current) return
        if(!refSim.current.validate() || simData?.length < 10 || !simData?.match(/(^[78]?9[0-9]{9}$)|(^8970[0-9]{13,18}$)/ui))
        {
            refState.current.show("Номер не корректен", true, 3000)
            return
        }
        if(!refImei.current.validate())
        {
            refState.current.show("IMEI не корректен", true, 3000)
            return

        }
        dataClientSimAdd.current = {clientId: crClient?.id, num: simData, imei: simImei}
        exClientSimAdd().then((e)=>{
            if(e?.success)
            {
                if(refState.current)refState.current.show("Сим карта добавлена",false,5000)
                loadSimList()
                return

            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)

        })




    }

    const handleReadGmail = ()=>{
        if(!crClient) return
        setPauseGmail(true)
        dataEsiaGmail.current = {clientId: crClient?.id}
        exEsiaGmail().then((e)=>{
            if(e?.success)
            {
                if(refState.current)refState.current.show("Процесс считывания запущен, обновите через 10 секунд",false,5000)
                return

            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)
        })

        setTimeout(()=>setPauseGmail(false),3000)
    }

    const handleEsiaNew = ()=>{
        if(!crClient) return
        const quest = window.confirm("Вы уверены что хотите изменить логин?")
        if(! quest) return


        dataEsiaNew.current= {clientId: crClient?.id}
        exEsiaNew().then((e)=>{
            if(e?.success)
            {
                loadClientList()
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)
        })
    }
    const buildEsiaCont = ()=>{
        const esiaLogin = crClient?.esiaLogin  ? crClient?.esiaLogin : "-"
        const esiaPass = esiaLogin?.length > 5 ? `GU${esiaLogin}` : "-"
        const vrVal = crClient?.number ? crClient?.number.slice(-3) : "-"
        return(
            <div className={styles.esiaMainCont}>
                <div className={"row w-100 "}>
                    <div className={"d-flex col-md-6 align-content-start"}>
                        <div className={styles.esiaCont}>
                            <div
                                onClick={async ()=>await navigator.clipboard.writeText(esiaLogin)}
                            >Логин : <span>{esiaLogin}</span></div>
                            <div
                                onClick={async ()=>await navigator.clipboard.writeText(esiaPass)}
                            >Пароль : <span>{esiaPass}</span></div>
                            <div
                                onClick={async ()=>await navigator.clipboard.writeText(vrVal)}
                            >Код : <span>{vrVal}</span></div>
                        </div>

                    </div>
                    <div className={"d-flex col-md-6 align-content-start"}>
                        <div className={styles.esiaCont}>
                            <div className={styles.guLine}>
                                <div>
                                    ГУ(создать) : <span><Link to={'https://www.gosuslugi.ru/665511/1/form'} target={"_blank"}>открыть</Link></span>
                                </div>
                                <div className={styles.imBuffCont}
                                    onClick={async ()=>await navigator.clipboard.writeText('https://www.gosuslugi.ru/665511/1/form')}
                                ><img className={styles.imBuff} src={imgBuf}/></div>
                            </div>
                            <div className={styles.guLine}>
                                <div>
                                    ГУ(подтвердить) : <span><Link to={'https://www.gosuslugi.ru/655212/1/form'} target={"_blank"}>открыть</Link></span>
                                </div>
                                <div className={styles.imBuffCont}
                                     onClick={async ()=>await navigator.clipboard.writeText('https://www.gosuslugi.ru/655212/1/form')}

                                ><img className={styles.imBuff} src={imgBuf}/></div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className={"row w-100 "}>
                    <div className={"d-flex col-md-12 align-content-start justify-content-center"}>
                        <div className={styles.esiaCont}>
                            <div className={styles.mailCont}>
                                {buildEsiaMail()}
                            </div>
                        </div>

                    </div>
                </div>
                <div className={"row w-100 "}>
                    <div className={"d-flex col-md-12 align-content-start justify-content-center"}>
                        <ButtonContainer resize={true} my={10}>
                            <button type="button" className="btn btn-face "
                                    onClick={handleEsiaNew}
                                    disabled={!crClient}
                            >Новый логин</button>
                            <button type="button" className="btn btn-face "
                                    disabled={pauseGmail || !crClient}
                                    onClick={handleReadGmail}
                            >Считать gmail</button>
                            <button type="button" className="btn btn-face "
                                    disabled={!crClient}
                                    onClick={loadEsiaList}
                            >Обновить</button>

                        </ButtonContainer>
                    </div>
                </div>

            </div>


        )
    }

    const buildEsiaMail = () =>{
        const x = esiaList?.map((item, idx)=>{
            const date = moment(item?.date).format('DD.MM.YYYY HH:MM')
            let type = "Не известно"
            let cont
            if(item?.type?.match(/url/ui)){
                type = "ссылка на госсуслуги"
                cont = <Link to={item?.val} target={"_blank"}>перейти</Link>
            }
            if(item?.type?.match(/pass/ui))
            {
                type = "временный пароль"
                cont = <div onClick={async ()=>await navigator.clipboard.writeText(item?.val)} style={{cursor:"pointer"}}>{item?.val}</div>
            }
            return(
                <tr key={idx} >
                    <td >
                        {date}
                    </td>
                    <td >
                        {item?.esiaLogin}
                    </td>
                    <td >
                        {type}
                    </td>
                    <td >
                        {cont}
                    </td>
                </tr>
            )
        })
        return(
            <table className={styles.esiaTable}><tbody>{x}</tbody></table>
        )

    }

    //useEffect(()=>{console.log(docData)},[docData])

    const handleDocUpdate = () =>{
        if(!crClient ) return
        if(!refState.current || !refDocState) return
        if(refFamily.current && !refFamily.current.validate())
        {
            refState.current.show("Фамилия не корректна", true, 2000)
            return
        }
        if(refName.current && !refName.current.validate())
        {
            refState.current.show("Имя не корректно", true, 2000)
            return
        }
        if(refMiddleName.current && !refMiddleName.current.validate())
        {
            refState.current.show("Отчество не корректно", true, 2000)
            return
        }
        if(refBirthDate.current && !refBirthDate.current.validate())
        {
            refState.current.show("Дата рождения не корректна", true, 2000)
            return
        }
        if(refSerial.current && !refSerial.current.validate())
        {
            refState.current.show("Серия документа не корректна", true, 2000)
            return
        }
        if(refNumber.current && !refNumber.current.validate())
        {
            refState.current.show("Номер документа не корректен", true, 2000)
            return
        }
        if(refDocDate.current && !refDocDate.current.validate())
        {
            refState.current.show("Дата выдачи документа не корректна", true, 2000)
            return
        }
        if(refIssuer.current && !refIssuer.current.validate())
        {
            refState.current.show("«Кем выдан» не корректен", true, 2000)
            return
        }
        if(refSnils.current && !refSnils.current.validate())
        {
            refState.current.show("СНИЛС не корректен", true, 2000)
            return
        }







        dataClientUpdate.current = {
            clientId:crClient?.id,
            family: docData?.family?.length ? docData?.family : undefined,
            name: docData?.name?.length ? docData?.name : undefined,
            middleName: docData?.middleName?.length ? docData?.middleName : undefined,
            birthDate: docData?.isoBirthDate?.length ? docData?.isoBirthDate : undefined,


            serial: docData?.docSerial?.length ? docData?.docSerial : undefined,
            number: docData?.docNumber?.length ? docData?.docNumber : undefined,
            issueDateFrom: docData?.isoDocDate?.length ? docData?.isoDocDate : undefined,

            issuer: docData?.docIssuer?.length ? docData?.docIssuer : undefined,
            snils: docData?.shils?.length ? docData?.shils : undefined,
            gender: docData?.gender,
            nation: nation
        }

        exClientUpdate().then((e)=>{
            if(e?.success)
            {
                if(refDocState.current)refDocState.current.show( "Данные обновлены",false,8000)
                loadClientList()
                return
            }
            if(refDocState.current)refDocState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)
        })

    }


    const normName = (str : string)=>{
        if(!str) return ""
        const xArr = str?.trim()?.split(' ')
        const xArrPn = xArr?.map((item)=>{
            const x = item?.toLowerCase()
            return (String(x).charAt(0).toUpperCase() + String(x).slice(1)).trim();
        })
        const rs = xArrPn?.join(' ')
        //console.log(`rs .${rs}.`)
        return rs

    }

    const normDate = (str:string):{
        iso:string|null
        text:string
    }=>{
        if(!str) return {text:"",iso:null}
        const x = str?.replace(/[^0-9]/uig,'')
        if(!x?.match(/[0-9]{8}/ui)) return {text:str,iso:null}
        const year = x?.substring(4)
        const day = x?.substring(0,2)
        const month = x?.substring(2,4)
        const isoDate = `${year}-${month}-${day}`
        const dt = moment(isoDate).format("DD.MM.YYYY")
       // console.log(`mormDate ${dt} ${isoDate}`)

        return {
            text: dt,
            iso: isoDate
        }

    }


    const buildWorkItem = ()=>{
        return (
            <div className={styles.workItem}>
                <div>
                    <ErrorLineItem ref={refState}/>
                </div>
                <WaitLoader loading={ldClientSimAdd || ldrUploadItem || ldrClientList || ldrNewClient ||
                    ldrClientUpdate || ldrClientEsia || ldrEsiaNew || ldrEsiaGmail || ldrClientSim || ldClientSimRemove || ldClientSimRefresh ||
                    ldClientSimActivate} api={rsClientEsia} onlyLoading={true}>

                </WaitLoader>
            </div>
        )
    }

    const handleNewClient = ()=>{
        exNewClient().then((e)=>{
            if(e?.success)
            {
                setBaseState({
                    page:0,
                    id: e?.payload
                })
                loadClientList()
                return
            }
            if(refState.current)refState.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,3000)
        })
    }


    return (
        <div className={styles.mainCont}>

            <div className={styles.tabCont}>
                {buildTabList()}
                <div className={styles.tabContent}>
                    {buildWorkItem()}

                    {crTab === 0 && buildFaceCont()}
                    {crTab === 1 && buildDocCont()}
                    {crTab === 2 && buildSimCont()}
                    {crTab === 3 && buildEsiaCont()}
                    {crTab === 4 && buildCardCont()}
                </div>
            </div>
            <ButtonContainer resize={true} my={10}>
                <button type="button" className="btn btn-face "
                        onClick={handleNewClient}
                >Новый клиент</button>
            </ButtonContainer>
            <TableItem
                data={clientList}
                ref={refClientList}
                exportExcel={true}
                onReload={()=>loadClientList()}
                onPageCount={50}
                saveState={true}
                //lockRecord={ldrLoadImage}
                baseState={{
                    state: baseState,
                    setState: setBaseState
                } }

                onRecord={(e:any)=>setCrClient(e)}
                column={[
                    {
                        title: "Пользователь",
                        fieldId: "userId",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "Дата",
                        fieldId: "createdAt",
                        type: 4,
                        mode: "s"
                    },
                    {
                        title: "Фио",
                        fieldId: "fio",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "Документ",
                        fieldId: "doc",
                        type: 0,
                        mode: "fs"
                    },
                    {
                        title: "esia",
                        fieldId: "esiaLogin",
                        type: 0,
                        mode: "f"
                    },
                ]}

            />



        </div>
    )


}